module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub border marg-20-bottom"
  }, [_c('div', {
    staticClass: "sub__user-header space-between flex align-center"
  }, [_c('div', {
    staticClass: "flex align-center"
  }, [_c('img', {
    staticClass: "marg-20-right rounded sub__user-img",
    attrs: {
      "src": _vm.user.default_thumb_url,
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('DDropdown', [_c('ul', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('li', [_c('a', {
    staticClass: "marg-5-left text-link",
    attrs: {
      "href": '/calendars/' + _vm.user.user_calendar_id,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['see_calendar']))])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setActiveAbsentUser(_vm.user)
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].add_sub_to_multiple_lessons))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "sub__user-header__right"
  }, [_c('div', {
    staticClass: "absence-status"
  }, [_c('label', {
    staticClass: "d-label marg-10-bottom"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['absent_handled']))]), _vm._v(" "), _c('div', {
    staticClass: "absence__status",
    on: {
      "click": function($event) {
        return _vm.setSubStatusDropdown(12)
      }
    }
  }, [_c('div', {
    staticClass: "dot",
    class: _vm.schedulerUserHandledCls(_vm.user)
  }), _vm._v(" "), (_vm.isSubStatusDropdown(12)) ? _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.closeSubStatusDropdown),
      expression: "closeSubStatusDropdown"
    }],
    staticClass: "dropdown absence__status__dropdown sub-status__dropdown",
    class: {
      'sub-status__dropdown--loading': _vm.isSubmittingAbsenceStatus
    }
  }, [(_vm.isSubmittingAbsenceStatus) ? _c('div', {
    staticClass: "do-spinner__container"
  }, [_c('div', {
    staticClass: "do-spinner do-spinner--large"
  })]) : _vm._e(), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setAbsenceStatus(0)
      }
    }
  }, [_c('div', {
    staticClass: "dot dot-white"
  }), _vm._v("\n                " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.not_handled')) + "\n              ")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setAbsenceStatus(1)
      }
    }
  }, [_c('div', {
    staticClass: "dot"
  }), _vm._v("\n                " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.handled')) + "\n              ")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "absence-reasons"
  }, _vm._l((_vm.absenceReasons), function(reason) {
    return _c('div', {
      staticClass: "absence-reasons__absence"
    }, [_c('p', {
      staticClass: "absence-reasons__absence__note"
    }, [_c('label', {
      staticClass: "d-label"
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['note']) + ":")]), _vm._v(" "), _c('weip', {
      attrs: {
        "lesson": reason,
        "noteType": "teacher_notes"
      },
      on: {
        "close": _vm.updateTeacherNote
      }
    })], 1), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "absence-reasons__absence__title"
    }, [_c('p', [_c('b', [_vm._v(_vm._s(reason.title))])]), _vm._v(" "), (reason.event_serial_id) ? _c('p', [(_vm.getIsAbsenceOngoing(reason)) ? [(_vm.getIsAbsenceAutoGenerated(reason)) ? _c('span', {
      staticClass: "badge badge--orange-warning badge--small badge--clickable",
      on: {
        "click": function($event) {
          return _vm.setTheEditAbsenceReason(reason)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['auto_created']))]) : _c('span', {
      staticClass: "badge badge--orange badge--small badge--clickable",
      on: {
        "click": function($event) {
          return _vm.setTheEditAbsenceReason(reason)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['ongoing_absence']))])] : _vm._e(), _vm._v(" "), (!_vm.getIsAbsenceOngoing(reason) && _vm.getIsAbsenceMultipleDays(reason)) ? _c('span', {
      staticClass: "badge badge--small"
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['multiple_days']))]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('p', [(_vm.getSerialListItem(reason)) ? [_vm._v("\n                " + _vm._s(_vm.formatDate(_vm.getSerialListItem(reason).from_date)) + "\n                - " + _vm._s(_vm.formatDate(_vm.getSerialListItem(reason).to_date)) + ", " + _vm._s(_vm.showTime(reason.start)) + " -\n                " + _vm._s(_vm.showTime(reason.end)) + "\n              ")] : [_vm._v("\n                " + _vm._s(_vm.absenceDate(reason.start)) + " -\n                "), _c('span', [_vm._v(_vm._s(_vm.showTime(reason.end)))])]], 2)]), _vm._v(" "), _c('div', {
      staticClass: "absence-reasons__absence__right"
    }, [_c('div', {
      staticClass: "absence-reasons__absence__right__edits"
    }, [_c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          placement: 'top'
        }),
        expression: "{\n                  arrow: true,\n                  placement : 'top'\n                }"
      }],
      staticClass: "icon-bin icon__bg-circle deleteAbsence",
      attrs: {
        "content": _vm.$t('vue2.common.delete')
      },
      on: {
        "click": function($event) {
          return _vm.setReadyToDelete(reason)
        }
      }
    }), _vm._v(" "), (_vm.getSerialListItem(reason)) ? _c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          placement: 'top'
        }),
        expression: "{\n                  arrow: true,\n                  placement : 'top'\n                }"
      }],
      staticClass: "icon-wrench icon__bg-circle",
      attrs: {
        "content": _vm.$t('vue2.common.edit')
      },
      on: {
        "click": function($event) {
          return _vm.setTheEditAbsenceReason(reason)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          placement: 'left'
        }),
        expression: "{\n                  arrow: true,\n                  placement : 'left'\n                }"
      }],
      staticClass: "activity-log icon__bg-circle",
      attrs: {
        "content": _vm.i18n[_vm.locale]['log']
      },
      on: {
        "click": function($event) {
          return _vm.showLog(reason)
        }
      }
    }, [_c('span', {
      staticClass: "icon-clock"
    })])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "sub-body"
  }, [_c('h4', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['lessons_on_day']) + ": " + _vm._s(_vm.sortedEvents.length) + "\n      "), _c('br'), _vm._v("\n      " + _vm._s(_vm.i18n[_vm.locale]['lessons_affected_by_absence']) + ": " + _vm._s(_vm.overlappingArr.length) + "\n    ")]), _vm._v(" "), (_vm.sortedEvents.length > 0) ? _c('table', {
    staticClass: "sub-table"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$filters.capitalize(_vm.showDate(_vm.sortedEvents[0].start))))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['subject']))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['class']))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['same_time']))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['substitute']))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['substitute_notes']))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['status']))])]), _vm._v(" "), _vm._l((_vm.sortedEvents), function(lesson, lessonIdx) {
    return _c('tr', {
      key: _vm.user.id + '_' + lesson.id,
      staticClass: "sub-lesson",
      class: [{
        'lesson-overlaps': lesson.v_isOverlapping
      }, {
        'sub-lesson__absence-overlap--handled': lesson.v_status && lesson.v_status !== 2
      }, {
        'sub-lesson__absence-overlap--pending': lesson.v_status === 2
      }],
      attrs: {
        "data-uuid": _vm.user.id + '_' + lesson.id
      }
    }, [_c('td', {
      staticClass: "sub-lesson__time",
      attrs: {
        "aria-i18n": _vm.i18n[_vm.locale]['absent']
      }
    }, [_c('div', {
      staticClass: "sub-lesson__time__content"
    }, [_c('div', [_vm._v(_vm._s(_vm.$filters.LT(lesson.start)) + " - " + _vm._s(_vm.$filters.LT(lesson.end)))]), _vm._v(" "), _c('button', {
      staticClass: "bttn bttn-sub-small hint--right",
      attrs: {
        "aria-label": _vm.i18n[_vm.locale]['split_lesson']
      },
      on: {
        "click": function($event) {
          return _vm.setActiveSplitLesson(lesson)
        }
      }
    }, [_c('span', {
      staticClass: "icon-wrench"
    })])])]), _vm._v(" "), _c('td', {
      staticClass: "sub-lesson__title"
    }, [_vm._v("\n          " + _vm._s(lesson.title) + "\n        ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "100px"
      }
    }, _vm._l((lesson.klassesAndOther), function(cal) {
      return _c('a', {
        key: cal.id,
        attrs: {
          "href": cal.url
        }
      }, [_vm._v("\n            " + _vm._s(cal.name) + "\n          ")])
    }), 0), _vm._v(" "), _c('td', {
      staticClass: "sub-lesson__others"
    }, [(lesson.v_others.length > 0) ? _c('p', [_c('b', [_vm._v(_vm._s(_vm.i18n[_vm.locale].on_the_lesson))])]) : _vm._e(), _vm._v(" "), _vm._l((lesson.v_others), function(user, othersIdx) {
      return (othersIdx < 3 || lesson.showAllOtherOnLesson) ? _c('div', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            arrow: false,
            zIndex: 123123123123,
            placement: 'top-start',
            onShow: function () { return user.v_isUserAbsentFromLesson.length > 0; }
          }),
          expression: "{\n                  arrow: false,\n                  zIndex: 123123123123,\n                  placement : 'top-start',\n                  onShow: () => user.v_isUserAbsentFromLesson.length > 0\n                }"
        }],
        key: user.id,
        staticClass: "sub-lesson__others__user",
        class: {
          'sub-lesson__others__user--absent': user.v_isUserAbsentFromLesson.length > 0
        },
        attrs: {
          "content": user.v_isUserAbsentFromLesson
        }
      }, [(user.v_isUserAbsentFromLesson.length > 0) ? _c('span', {
        staticClass: "icon-warning"
      }) : _c('span', {
        staticClass: "icon-user"
      }), _vm._v("\n            " + _vm._s(user.name) + "\n          ")]) : _vm._e()
    }), _vm._v(" "), (lesson.v_others.length > 3 && !lesson.showAllOtherOnLesson) ? _c('span', {
      staticClass: "text-blue pointer",
      on: {
        "click": function($event) {
          return _vm.setShowOtherOnLesson(lesson.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].see_all))]) : _vm._e(), _vm._v(" "), (lesson.showAllOtherOnLesson) ? _c('span', {
      staticClass: "text-blue pointer",
      on: {
        "click": function($event) {
          return _vm.setShowOtherOnLesson(null)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].see_less))]) : _vm._e(), _vm._v(" "), (lesson.otherLessonsInKlassThatOverlap.length > 0) ? _c('div', {
      staticClass: "other_in_klass"
    }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.i18n[_vm.locale].same_time_in_class))])]), _vm._v(" "), _vm._l((lesson.otherLessonsInKlassThatOverlap), function(otherLesson, otherKey) {
      return (otherKey < 2 || lesson.showOtherLessonsInKlassThatOverlap) ? _c('div', {
        key: otherLesson.id,
        staticClass: "lesson",
        style: ({
          'borderLeft': '2px solid ' + otherLesson.color + ''
        })
      }, [_vm._v("\n              " + _vm._s(otherLesson.title) + ", " + _vm._s(_vm.$filters.LT(otherLesson.start)) + " - " + _vm._s(_vm.$filters.LT(otherLesson.end)) + "\n              "), _vm._l((otherLesson.users), function(user, key) {
        return (key < 2 || otherLesson.showAllUsers) ? _c('div', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              arrow: false,
              placement: 'top',
              onShow: function () { return user.v_isUserAbsent; }
            }),
            expression: "{\n                     arrow: false,\n                     placement: 'top',\n                     onShow: () => user.v_isUserAbsent\n                   }"
          }],
          key: user.id,
          class: {
            'other-lesson-user--absent': user.v_isUserAbsent
          },
          attrs: {
            "content": user.v_absenceInfo
          }
        }, [(user.v_isUserAbsent) ? _c('span', {
          staticClass: "icon-warning"
        }) : _c('span', {
          staticClass: "icon-user"
        }), _vm._v("\n                " + _vm._s(user.name) + "\n              ")]) : _vm._e()
      }), _vm._v(" "), (otherLesson.users.length > 2 && !otherLesson.showAllUsers) ? _c('span', {
        staticClass: "text-blue pointer",
        on: {
          "click": function($event) {
            return _vm.setOtherLessonShowAllUsers(otherLesson.id)
          }
        }
      }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].see_all))]) : _vm._e(), _vm._v(" "), (otherLesson.showAllUsers) ? _c('span', {
        staticClass: "text-blue pointer",
        on: {
          "click": function($event) {
            return _vm.setOtherLessonShowAllUsers(null)
          }
        }
      }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].see_less))]) : _vm._e()], 2) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (lesson.otherLessonsInKlassThatOverlap.length > 2 && !lesson.showOtherLessonsInKlassThatOverlap) ? _c('span', {
      staticClass: "text-blue pointer",
      on: {
        "click": function($event) {
          return _vm.setShowOtherLessonsInKlassThatOverlap(lesson.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].view_all_lessons))]) : _vm._e(), _vm._v(" "), (lesson.showOtherLessonsInKlassThatOverlap) ? _c('span', {
      staticClass: "text-blue pointer",
      on: {
        "click": function($event) {
          return _vm.setShowOtherLessonsInKlassThatOverlap(null)
        }
      }
    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].view_less_lessons))]) : _vm._e()], 2), _vm._v(" "), _c('td', {
      class: {
        'd-select-lookalike': !_vm.openDSelect(lesson) && lesson.v_subs.length === 0
      },
      staticStyle: {
        "width": "40%"
      },
      attrs: {
        "aria-placeholder-label": _vm.i18n[_vm.locale]['search']
      },
      on: {
        "click": function($event) {
          return _vm.setDSelect(lesson, lessonIdx)
        }
      }
    }, [(_vm.openDSelect(lesson)) ? _c('dSelectSub', {
      attrs: {
        "show": _vm.openDSelect(lesson),
        "items": _vm.usersForDSelect,
        "startTime": lesson.start,
        "endTime": lesson.end,
        "user": _vm.user,
        "eventId": lesson.id,
        "itemsSelected": lesson.v_subs,
        "othersOnLesson": lesson.v_others,
        "isUpdatingUsers": _vm.isUpdatingPotentialSubs
      },
      on: {
        "add": function($event) {
          return _vm.addSubstitute($event, lesson)
        },
        "remove": function($event) {
          return _vm.removeSubstitute($event, lesson)
        }
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.openDSelect(lesson) && lesson.v_subs.length > 0) ? _c('div', {
      staticClass: "d-select__input-look"
    }, _vm._l((lesson.v_subs), function(sub) {
      return _c('div', {
        key: sub.id,
        staticClass: "d-select__selected__item",
        class: {
          'd-select__seleted__item--is-error-user': sub.isErrorUser
        }
      }, [_vm._v("\n              " + _vm._s(sub.name) + "\n              "), (_vm.subLessonsThatOverlap(lesson, sub.dayAllEvents).length > 0) ? _c('div', {
        staticClass: "item__icon-warning marg-5-left hint--error hint--top",
        attrs: {
          "aria-label": _vm.textFromSubLessonsThatOverlap(lesson, sub.dayEvents)
        }
      }) : _vm._e(), _vm._v(" "), (!sub.isErrorUser) ? _c('div', {
        staticClass: "d-select__selected__item__remove",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.removeSubstitute(sub, lesson)
          }
        }
      }, [_vm._v("×\n              ")]) : _vm._e()])
    }), 0) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "sub_teacher_notes",
      class: [{
          'icon-pencil eip-lookalike eip-lookalike--empty': !_vm.isActiveEIP(lessonIdx) && lesson.teacher_notes.length < 1
        },
        {
          'eip-lookalike eip-filled': !_vm.isActiveEIP(lessonIdx) && lesson.teacher_notes.length > 0
        }
      ],
      staticStyle: {
        "width": "250px"
      },
      on: {
        "click": function($event) {
          return _vm.setActiveEIP(lessonIdx)
        }
      }
    }, [(!_vm.isActiveEIP(lessonIdx)) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(lesson.teacher_notes)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isActiveEIP(lessonIdx)) ? _c('weip', {
      attrs: {
        "noteType": "teacher_notes",
        "lesson": lesson,
        "isOpen": true
      },
      on: {
        "close": _vm.updateTeacherNote
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20px"
      }
    }, [(lesson.v_substituted && !_vm.isSubStatusPendingActive) ? _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          placement: 'left',
          arrow: false,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window'
        }),
        expression: "{\n              placement: 'left',\n              arrow: false,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n          }"
      }],
      staticClass: "flex set-status",
      attrs: {
        "content": _vm.$t('vue2.sub_scheduler.is_substituted')
      }
    }, [_c('div', {
      staticClass: "dot"
    })]) : _c('div', {
      staticClass: "flex set-status pointer",
      on: {
        "click": function($event) {
          return _vm.setSubStatusDropdown(lesson.id)
        }
      }
    }, [_c('div', {
      staticClass: "dot",
      class: [_vm.statusDotClass(lesson), {
        'dot--loading': lesson.v_isLoading
      }]
    }), _vm._v(" "), _c('div', {
      staticClass: "arrow icon-arrow-down"
    }), _vm._v(" "), (_vm.isSubStatusDropdown(lesson.id)) ? _c('div', {
      directives: [{
        name: "on-clickaway",
        rawName: "v-on-clickaway",
        value: (_vm.closeSubStatusDropdown),
        expression: "closeSubStatusDropdown"
      }],
      staticClass: "dropdown sub-status__dropdown"
    }, [_c('ul', [(!lesson.v_substituted) ? _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setSubStatus(lesson, 0)
        }
      }
    }, [_c('div', {
      staticClass: "dot dot-white"
    }), _vm._v("\n                  " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.not_handled')) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.isSubStatusPendingActive) ? _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setSubStatus(lesson, 2)
        }
      }
    }, [_c('div', {
      staticClass: "dot dot-yellow"
    }), _vm._v("\n                  " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.pending')) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setSubStatus(lesson, 1)
        }
      }
    }, [_c('div', {
      staticClass: "dot"
    }), _vm._v("\n                  " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.handled')) + "\n                ")])])]) : _vm._e()])])])
  })], 2) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f7191d3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/SubsUser.vue
// module id = 1997
// module chunks = 1